export const mobile = {
  title: 'Controla tu tienda estés donde estés con solo tu móvil',
  benefit1: 'Administra tu inventario y sube imágenes de productos sin complicaciones',
  benefit2: 'Acepta pagos, haz seguimiento de los pedidos de tus clientes',
  benefit3: 'Ofrece cupones y descuentos especiales para aumentar las ventas',
  qr: 'Escanear QR',
  qrAndroidLabel: 'Google Play',
  qrIosLabel: 'App Store',
};
